/**
 * TEMPORARY MOCK — DELETE WHEN THE BACKEND IS READY.
 *
 * Simulates the response of `GET api/sidebar` while the backend is not available.
 * It is returned by `mockApiInterceptor` only when `environment.useMockApi` is true.
 *
 * Once the backend serves the sidebar endpoint:
 *   1. Delete this file and its export in `core/mocks/index.ts`.
 *   2. Remove the `sidebar` branch from `core/interceptors/mock-api/mock-api-interceptor.ts`.
 * The sidebar items, labels and badge counts will then come from the backend.
 */
import type { ISidebarResponse } from "@azm/core/services/sidebar";

export const MOCK_SIDEBAR: ISidebarResponse = {
	hasPrivacyPolicy: false,
	hasTermsAndConditions: false,
	menuItems: [
		{ code: "dashboard", label: "لوحة المعلومات", icon: "dashboard", routerLinkName: "dashboard" },
		{ code: "lawsuits", label: "الشكاوى", icon: "lawsuits", routerLinkName: "lawsuits" },
		{ code: "notes", label: "البلاغات", icon: "notes", routerLinkName: "notes" },
		{
			code: "professional-monitoring",
			label: "الامتثال المهني",
			icon: "professional-monitoring",
			routerLinkName: "professional-monitoring",
		},
		{ code: "lawyer-inquiry", label: "الاستعلام عن المحامي", icon: "lawyer-inquiry", routerLinkName: "lawyer-inquiry" },
		{
			code: "help",
			label: "المساعدة",
			icon: "help",
			children: [
				{ code: "faq", label: "الأسئلة الشائعة", parentCode: "help", routerLinkName: "faq" },
				{ code: "contact-us", label: "تواصل معنا", parentCode: "help", routerLinkName: "contact-us" },
			],
		},
	],
};
